import { JSX, useState } from "react";
import cn from "classnames";
import { ISubdimension } from "@/service/review-period";
import { ChevronRightIcon } from "@/shared/icons";
import { ComparisonMode } from "@/pages/assessment/_components";
import { SkillLevelItem } from "../skill-level-item";

interface SubdimensionItemProps {
  subdimension: ISubdimension;
  comparisonMode: ComparisonMode;
}

export const SubdimensionItem = ({ subdimension, comparisonMode }: SubdimensionItemProps): JSX.Element => {
  const [isExpanded, setIsExpanded] = useState(true);

  const hasSkills = subdimension.skills && subdimension.skills.length > 0;

  const handleToggle = () => {
    if (hasSkills) {
      setIsExpanded(!isExpanded);
    }
  };

  return (
    <>
      <div
        className={cn(
          "grid grid-cols-[1fr_216px_60px_40px] items-center gap-4 py-1",
          hasSkills && "cursor-pointer hover:bg-gray-50",
        )}
        onClick={handleToggle}
      >
        <div className={cn("text-eerie-black col-span-4 flex items-center gap-2 pl-2 text-sm")}>
          <span>{subdimension.subdimension}</span>
          {hasSkills && (
            <ChevronRightIcon className={cn("transition-transform duration-200", isExpanded && "rotate-90")} />
          )}
        </div>
      </div>
      {hasSkills && (
        <div
          className={cn(
            "overflow-hidden transition-[max-height] duration-300 ease-in-out",
            isExpanded ? "max-h-[2000px]" : "max-h-0",
          )}
        >
          {subdimension.skills
            .filter((skill) => skill.actual_level !== 0)
            .map((skill, index) => (
              <SkillLevelItem key={index} skill={skill} comparisonMode={comparisonMode} />
            ))}
        </div>
      )}
    </>
  );
};
